export default {
  title: {
    id: 'bo_sellers-orders-drawers-order_recap-order_status-title',
    defaultMessage: 'Order status',
  },
  creationStatus: {
    id: 'bo_sellers-orders-drawers-order_recap-status-creation',
    defaultMessage: 'Creation',
  },
  paidStatus: {
    id: 'bo_sellers-orders-drawers-order_recap-status-paid',
    defaultMessage: 'Paid',
  },
  confirmedStatus: {
    id: 'bo_sellers-orders-drawers-order_recap-status-confirmed',
    defaultMessage: 'Confirmed',
  },
  shippedStatus: {
    id: 'bo_sellers-orders-drawers-order_recap-status-shipped',
    defaultMessage: 'Shipped',
  },
  pickupDate: {
    id: 'bo_sellers-orders-drawers-order_recap-status-pickup',
    defaultMessage: 'Pickup',
  },
  deliveredStatus: {
    id: 'bo_sellers-orders-drawers-order_recap-status-delivered',
    defaultMessage: 'Delivered',
  },
} as const
